import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LevelTypesState {
  loading: boolean;
  data: object;
  error: object;
}

const initialState: LevelTypesState = {
  loading: false,
  data: [],
  error: {},
};

export const LevelTypesSice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    // actions
    loadLevelTypes: (state) => {
      return {
        ...state,
        loading: true,
        data: [],
        error: {},
      };
    },
    loadLevelTypesSuceess: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: {},
      };
    },
    loadLevelTypesError: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loadLevelTypes, loadLevelTypesSuceess, loadLevelTypesError } =
  LevelTypesSice.actions;

export const LevelTypesReducer = LevelTypesSice.reducer;
